import React from 'react';
import TypeScale from '@identity/type';
import { TextWrapper, Content } from '@identity/wrappers';
import { shortDate2 } from '@lib/dates';
import { Wrapper, ImageWrapper } from './styles';
import { Link } from 'gatsby';
import profilePhoto from '../../../static/images/sydney-profile.png';

const Footer = ({ title, description, slug, hero, noLink }) => {
  const date = new Date();
  const ISODate = date.toISOString();

  return (
    <Wrapper space={{ padding: !noLink && 'bottom-lg' }} noLink={noLink}>
      {noLink ? (
        <div>
          <TypeScale.H3 spacing={{ padding: 'bottom-sm' }}>
            {title}
          </TypeScale.H3>
          <TypeScale.SMALL>{shortDate2(ISODate)}</TypeScale.SMALL>
          {description && (
            <TypeScale.P spacing={{ margin: 'bottom-sm' }}>
              {description.description}
            </TypeScale.P>
          )}
          <div style={{ display: 'flex' }}>
            <ImageWrapper>
              <img src={profilePhoto} />
            </ImageWrapper>
            <TypeScale.SMALL>By Sydney Thompson</TypeScale.SMALL>
          </div>
        </div>
      ) : (
        <Link to={`/blog/${slug}`}>
          <TypeScale.H3 spacing={{ padding: 'bottom-sm' }}>
            {title}
          </TypeScale.H3>
          <TypeScale.SMALL>{shortDate2(ISODate)}</TypeScale.SMALL>
          {description && (
            <TypeScale.P spacing={{ margin: 'bottom-sm' }}>
              {description.description}
            </TypeScale.P>
          )}
          <div style={{ display: 'flex' }}>
            <ImageWrapper>
              <img src={profilePhoto} />
            </ImageWrapper>
            <TypeScale.SMALL>By Sydney Thompson</TypeScale.SMALL>
          </div>
        </Link>
      )}
    </Wrapper>
  );
};

export default Footer;
